import React, {useEffect, useState} from "react";
import {ExpandModal} from "./ExpandModal";
import {Button, Stack, Typography} from "@mui/material";


export const PersonaModal = ({open, handleClose, text, onSuccess}) => {
  const [content, setContent] = useState("");

  useEffect(() => {
    if (open) {
      setContent(text || "");
    }
  }, [open, text])

  const handleUpdateText = (e) => {
    const updatedText = e.target.innerText?.trim();
    if (text !== updatedText) {
      setContent(updatedText)
    }
  }

  return (
    <ExpandModal
      open={open}
      handleClose={handleClose}
      enableBackdrop={true}
    >
      <Stack direction={"column"} gap={2} sx={{height: "100%"}}>

        <Typography fontWeight={700}>System Prompt</Typography>
        <Stack direction={'column'}
               sx={{flex: 1, overflowY: "auto", height: "100%", borderRadius: 1, bgcolor: content ? "#c4c4c421" : "",}}>
          <Typography
            fontSize={15}
            component={"pre"}
            suppressContentEditableWarning
            contentEditable
            sx={{
              // fontFamily: "Consolas",
              textWrap: "wrap", flex: 1,
              p: 1,
              outline: "none",
              border: "none",
              "&:focus": {
                outline: "none",
                border: "none"
              }
            }}
            // onFocus={(e) => e.target.blur()} // 👈 Immediately removes focus
            onBlur={handleUpdateText}
          >
            {content}
          </Typography>
        </Stack>
        {/*<InputBase*/}
        {/*  value={content}*/}
        {/*  size={"small"}*/}
        {/*  label={"Persona"}*/}
        {/*  fullWidth*/}
        {/*  placeholder={"Describe persona"}*/}
        {/*  sx={{border: 1, borderColor: 'divider', borderRadius: 0, p: 1}}*/}
        {/*  multiline*/}
        {/*  minRows={3}*/}
        {/*  // helperText={"Ask for confirmation"}*/}
        {/*  onChange={(e) => setContent(e.target.value)}*/}
        {/*/>*/}
        <Stack direction={"row"} gap={2} alignItems={"center"}>
          <Button
            variant={"modal"}
            color={"secondary"}
            onClick={() => {
              onSuccess(content);
              setContent("");
              handleClose();
            }}
          >
            Save
          </Button>
          <Button
            variant={"ghost"}
            color={"secondary"}
            onClick={() => {
              setContent("");
              handleClose();
            }}
          >
            Cancel
          </Button>
        </Stack>
      </Stack>
    </ExpandModal>
  )
}